import { DashboardStage } from './types';
import {
    CheckSquareIcon,
    CodeSquareIcon,
    ProfileSquareIcon,
    RecruitingInterviewIcon,
    StarSquareIcon,
} from '../../../assets/icons/common';

/**
 * The hiring funnel in the order an applicant walks through it. Drives the
 * summary cards, the job box tabs and the copy shown when a stage is empty.
 */
export const dashboardStages: DashboardStage[] = [
    {
        id: 'RecruitingInterview',
        title: 'Recruiting interview',
        cardTitle: 'Recruiting interview',
        icon: RecruitingInterviewIcon,
        emptyState: 'There are no matched recruiting interview available for you.\nPlease come back later.',
    },
    {
        id: 'MultipleChoice',
        title: 'Multiple choice',
        cardTitle: 'Multiple choice',
        icon: CheckSquareIcon,
        emptyState: 'There are no matched multiple-choice exams available for you.\nPlease come back later.',
    },
    {
        id: 'Coding',
        title: 'Coding',
        cardTitle: 'Coding exam',
        icon: CodeSquareIcon,
        emptyState: 'There are no coding exams available for you.\nPlease come back later.',
    },
    {
        id: 'Interview',
        title: 'Personal interview',
        cardTitle: 'Personal interview',
        icon: ProfileSquareIcon,
        emptyState: 'There are no personal interviews available for you.\nPlease come back later',
    },
    {
        id: 'FinalResult',
        title: 'Final result',
        cardTitle: 'Final result',
        icon: StarSquareIcon,
        emptyState: 'There are no final results available for you.\nPlease come back later',
    },
];
